import React from 'react';
import {Box, Typography} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import {defaultColors} from "../ColorSchema";

function SendScreen(props) {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            sx={{
                height: "100%"
            }}
        >
            <MailOutlineIcon sx={{
                fontSize: 56, mb: 1,
                color: props.invert ? defaultColors.primary  : defaultColors.on_primary
            }}/>
            <Typography variant="h6" component="p" color={props.invert ? defaultColors.primary  : defaultColors.on_primary}>
                {'Deine Anfrage wurde verschickt.'}
            </Typography>
            <Typography variant="body2" sx={{mt: 1}} color={props.invert ? defaultColors.primary  : defaultColors.on_primary}>
                {'Ich werde mich bald möglichst bei dir melden.'}
            </Typography>
        </Box>
    );
}

export default SendScreen;